/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_BothInputs */

const en_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const ar_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#كلاهما`)
};

const bn_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const de_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const es_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const fr_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const pt_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const zh_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const tr_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const ru_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

const pl_svtag_both = /** @type {(inputs: Svtag_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#BOTH`)
};

/**
* | output |
* | --- |
* | "#BOTH" |
*
* @param {Svtag_BothInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_both = /** @type {((inputs?: Svtag_BothInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_BothInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_both(inputs)
	if (locale === "bn") return bn_svtag_both(inputs)
	if (locale === "de") return de_svtag_both(inputs)
	if (locale === "es") return es_svtag_both(inputs)
	if (locale === "fr") return fr_svtag_both(inputs)
	if (locale === "pt") return pt_svtag_both(inputs)
	if (locale === "zh") return zh_svtag_both(inputs)
	if (locale === "tr") return tr_svtag_both(inputs)
	if (locale === "ru") return ru_svtag_both(inputs)
	if (locale === "pl") return pl_svtag_both(inputs)
	return en_svtag_both(inputs)
});